var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonitorTraffic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.47852 12.5003V10.5004",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4785 12.5003V6.50049",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47852 12.5003V8.50037",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4785 12.5003V8.50037",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4785 12.5003V4.50012",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4785 12.5002V7.50037",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8309 20.5C15.7287 20.5 16.1649 21.9545 16.7502 23.1404C16.7386 23.2458 16.6862 23.3424 16.6042 23.4096C16.5222 23.4768 16.4172 23.5092 16.3116 23.5H7.70713C7.59776 23.5022 7.49163 23.4628 7.41021 23.3897C7.3288 23.3166 7.27816 23.2154 7.26855 23.1064C7.87008 21.9358 8.33506 20.5 10.1875 20.5H13.8309Z",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9041 0.5H2.11325C1.89736 0.504873 1.68454 0.552326 1.48703 0.639635C1.28951 0.726944 1.11117 0.852392 0.962248 1.00878C0.813325 1.16517 0.696744 1.34943 0.619193 1.55097C0.541643 1.75252 0.504649 1.9674 0.510334 2.18328V14.973C0.507647 15.1808 0.547864 15.3869 0.628468 15.5784C0.709072 15.7699 0.82833 15.9427 0.978781 16.0861C1.12923 16.2294 1.30764 16.3401 1.50285 16.4114C1.69805 16.4826 1.90585 16.5128 2.11325 16.5H21.9041C22.1117 16.5129 22.3197 16.4828 22.5152 16.4117C22.7106 16.3406 22.8893 16.2299 23.0401 16.0866C23.1908 15.9433 23.3104 15.7704 23.3913 15.5788C23.4722 15.3872 23.5127 15.181 23.5103 14.973V2.18328C23.5157 1.9672 23.4784 1.75218 23.4006 1.55055C23.3227 1.34891 23.2058 1.16462 23.0566 1.00824C22.9074 0.851869 22.7288 0.726479 22.531 0.639264C22.3333 0.552049 22.1202 0.504724 21.9041 0.5V0.5Z",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0107 20.5V18.5001",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0102,
    height: 24.0194,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorTraffic);
export default __webpack_public_path__ + "static/media/monitor_traffic.f526131b18e8bdc07614449ee0e3ed8c.svg";
export { ForwardRef as ReactComponent };